import zxcvbn from 'zxcvbn';

/**
 * Estimate a password strength with 5-point scale. It uses zxcvbn.
 * - https://github.com/dropbox/zxcvbn
 * @param password        Password value
 * @param matchingPattern Password matching regex pattern
 * @returns               Password strength score (0..4). GTE 2 should be OK.
 */
export const evaluatePasswordStrength =
  (matchingPattern: RegExp) => (password: string) => {
    const score = zxcvbn(password).score;

    if (score >= 2 && !password.match(matchingPattern)) {
      return 1;
    }

    return score;
  };
